var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineasDeTexto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6CED1"
    },
    points: "407.254,0 361.743,256 407.254,512 452.765,512 452.765,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECE7EA"
    },
    points: "407.258,0 407.258,512 59.235,512 59.235,79.644 116.124,56.889 138.879,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6CED1"
    },
    points: "138.879,0 138.879,79.644 59.235,79.644 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,167.822H116.127c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h234.238 c4.714,0,8.533,3.821,8.533,8.533S355.079,167.822,350.365,167.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,304.356H116.127c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h234.238 c4.714,0,8.533,3.821,8.533,8.533S355.079,304.356,350.365,304.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,349.867h-94.364c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533S355.079,349.867,350.365,349.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,88.178H173.016c-4.714,0-8.533-3.821-8.533-8.533c0-4.713,3.82-8.533,8.533-8.533h177.349 c4.714,0,8.533,3.821,8.533,8.533C358.898,84.357,355.079,88.178,350.365,88.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,213.333h-94.364c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533S355.079,213.333,350.365,213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,258.844h-94.364c-4.714,0-8.533-3.821-8.533-8.533c0-4.713,3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533C358.898,255.024,355.079,258.844,350.365,258.844z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.122,
    y: 341.333,
    style: {
      fill: "#F14742"
    },
    width: 94.364,
    height: 91.022
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M210.491,258.844h-94.364c-4.714,0-8.533-3.821-8.533-8.533c0-4.713,3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533C219.025,255.024,215.204,258.844,210.491,258.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M293.476,440.889h-37.475c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h37.475 c4.714,0,8.533,3.821,8.533,8.533S298.19,440.889,293.476,440.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M350.365,395.378h-94.364c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533S355.079,395.378,350.365,395.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M210.491,213.333h-94.364c-4.714,0-8.533-3.821-8.533-8.533s3.82-8.533,8.533-8.533h94.364 c4.714,0,8.533,3.821,8.533,8.533S215.204,213.333,210.491,213.333z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineasDeTexto);
export default __webpack_public_path__ + "static/media/lineas-de-texto.f756e38f3b32f0a224f2aedcf426f22b.svg";
export { ForwardRef as ReactComponent };